import {
  useMutation,
  useQuery,
  useQueryClient,
  type UseMutationResult,
  type UseQueryResult,
} from '@tanstack/react-query';
import {
  fetchTreatmentPlanTemplates,
  replaceTreatmentPlanTemplates,
} from '@/api/treatmentPlanTemplates/treatmentPlanTemplatesApi';
import type {
  TreatmentPlanTemplate,
  TreatmentPlanTemplateDraft,
} from '@/api/treatmentPlanTemplates/treatmentPlanTemplatesApi.types';
import { TREATMENT_PLAN_TEMPLATES_QUERY_KEY } from '@/constants/queryKeys';

export function useTreatmentPlanTemplatesQuery(
  isEnabled = true
): UseQueryResult<TreatmentPlanTemplate[], Error> {
  return useQuery({
    queryKey: TREATMENT_PLAN_TEMPLATES_QUERY_KEY,
    queryFn: fetchTreatmentPlanTemplates,
    enabled: isEnabled,
  });
}

export function useReplaceTreatmentPlanTemplatesMutation(): UseMutationResult<
  TreatmentPlanTemplate[],
  Error,
  TreatmentPlanTemplateDraft[]
> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: replaceTreatmentPlanTemplates,
    onSuccess: function store(templates) {
      queryClient.setQueryData(TREATMENT_PLAN_TEMPLATES_QUERY_KEY, templates);
    },
  });
}
